import { AudienceTimeSinceLastVisitTargetingAttributeFragment } from '@occc/graphql';

import { audienceFormInitialValues } from '../../AudienceCreatePage/AudienceFormInitialValues';

export const getLastVisitInitialValues = (
  lastVisit: AudienceTimeSinceLastVisitTargetingAttributeFragment,
) =>
  lastVisit
    ? {
        period: lastVisit.period,
        operator: lastVisit.timeSinceLastVisitOperator,
        amount: lastVisit.amount,
      }
    : audienceFormInitialValues['lastVisit'];
